$(document).ready(function() {
	$(document).foundation();
	$('#section-links .text').matchHeight();
});
